/**
 * Strip the `YYYY-MM-DD-` date prefix from next-week workout IDs.
 * e.g. "2026-05-25-workout-mon" → "workout-mon"
 * Keeps sync-map keys stable across the current-week / next-week boundary.
 */
export function nid(id: string): string {
  return id.replace(/^\d{4}-\d{2}-\d{2}-/, "");
}
